<template>
  <div class="list row">
    <div class="col-md-8 mr-4">
      <div class="input-group mb-3">
        <input type="date" v-validate="'required|min:10|max:10'" class="form-control mr-2" placeholder="Select start date" v-model="startDate"/>
        <input type="date" v-validate="'required|min:10|max:10'" class="form-control mr-2" placeholder="Select end date" v-model="endDate"/>
        <input type="text" v-validate="'required|min:9|max:9'" class="form-control mr-2" placeholder="Search by network ID" v-model="networkId"/>
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" type="button" @click="page = 1; retrieveSales();"><font-awesome-icon icon="search" /> Search</button>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <button class="btn btn-primary" @click="newSale"><font-awesome-icon icon="plus" /> Add Sale</button>
    </div>
    <div class="col-md-12 hgap"></div>
    <div class="col-md-8">
      <h4><font-awesome-icon icon="list-alt" /> Sales List</h4>
      <table class="gridview">
        <tr>
            <th>S/N</th><th>NetworkID</th><th>Surname</th><th>First Name</th><th>Product</th><th>Quantity</th><th>Sold Date</th>
        </tr>
        <tr class="" :class="{ active: index == currentIndex }" v-for="(sale, index) in sales" :key="index" @click="setActiveSale(sale, index)">
            <td>{{ index+1 }}</td><td>{{ sale.network_member_id }}</td><td>{{ sale.surname }}</td>
            <td>{{ sale.first_name }}</td><td>{{ sale.name }}</td><td>{{ sale.quantity }}</td><td>{{ sale.sold_date | moment("DD/MM/YYYY") }}</td>
        </tr>
      </table>
      <div class="col-md-12 hgap"></div>
      <div v-if="loading" class="justify-content-center">
        <font-awesome-icon icon="spinner" /> <span>Loading...please wait</span>
      </div>
      <table class="table table-borderless">
        <tr>
          <td>
            <div class="d-flex justify-content-center">
              Items per Page:
              <select v-model="pageSize" @change="handlePageSizeChange($event)">
                <option v-for="size in pageSizes" :key="size" :value="size">
                  {{ size }}
                </option>
              </select>
            </div>
          </td>
          <td>
            <div class="d-flex justify-content-end">
              <b-pagination v-model="page" :total-rows="count" :per-page="pageSize" prev-text="Prev" next-text="Next" @change="handlePageChange"></b-pagination>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="col-md-4">
      <div v-if="currentSale">
        <h4><font-awesome-icon icon="info-circle" /> Sale Details</h4>
        <table class="table">
        <tr>
          <td><strong>Network Member Id:</strong></td><td> {{ currentSale.network_member_id }}</td>
        </tr>
        <tr>
          <td><strong>Surname:</strong></td><td> {{ currentSale.surname }}</td>
        </tr>
        <tr>
          <td><strong>First Name:</strong></td><td> {{ currentSale.first_name }}</td>
        </tr>
        <tr>
          <td><strong>Product:</strong></td><td> {{ currentSale.name }}</td>
        </tr>
        <tr>
          <td><strong>product PV:</strong></td><td> {{ currentSale.pv }}</td>
        </tr>
        <tr>
          <td><strong>Quantity:</strong></td><td> {{ currentSale.quantity }}</td>
        </tr>
        <tr>
          <td><strong>Sold Date:</strong></td><td> {{ currentSale.sold_date | moment("dddd, MMMM Do YYYY") }}</td>
        </tr>
        <tr>
          <td><strong>Total PV:</strong></td><td> {{ currentSale.total_pv }}</td>
        </tr>
        </table>

        <!-- <a class="m-3 btn btn-sm btn-warning" :href="'/sales/' + currentSale.id"><font-awesome-icon icon="edit" /> Edit </a>-->
        <router-link :to="{ path: '/sales/' + currentSale.id }" class="m-3 btn btn-sm btn-warning"><font-awesome-icon icon="edit" /> Edit </router-link>
      </div>
      <div v-else>
        <br />
        <p>Please click on a Sale...</p>
      </div>
    </div>
  </div>
</template>

<script>
import SaleService from "../services/sale.service";

export default {
  name: "sales-list",
  data() {
    return {
      sales: [],
      currentSale: null,
      currentIndex: 0,
      startDate: null,
      endDate: null,
      networkId: "",
      page: 1,
      count: 0,
      pageSize: 100,
      pageSizes: [10, 15, 20, 25, 50, 100],
      totalPages: 0,
      loading: false
    };
  },
  methods: {
    /*retrieveSalesOld() {
      SaleService.getAll()
        .then(response => {
          this.sales = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },*/

    retrieveSales() {
      this.loading = true;
      if (this.page) {
        this.page = this.page - 1;
      }
      if (this.startDate && this.endDate) {
        this.networkId = "";
        SaleService.getTotalSalesByDate(new Date(this.startDate), new Date(this.endDate))
          .then(response => {
            this.count = response.data;
            //console.log(response.data);
          })
          .catch(e => {
            console.log(e);
          });

          SaleService.getSalesByDate(new Date(this.startDate), new Date(this.endDate), this.page, this.pageSize)
            .then(response => {
              this.sales = response.data;
              //console.log(response.data);
              this.loading = false;
            })
            .catch(e => {
              console.log(e);
            });
      }
      if (this.networkId) {
        this.startDate = null;
        this.endDate = null;
        SaleService.getTotalSalesByMemberId(this.networkId)
          .then(response => {
            this.count = response.data;
            //console.log(response.data);
            SaleService.getSalesByMemberIdPageable(this.networkId, this.page, this.pageSize)
              .then(response => {
                this.sales = response.data;
                this.loading = false;
              })
              .catch(e => {
                console.log(e);
              });
          })
          .catch(e => {
            console.log(e);
          });  
      }
      if (!this.startDate && !this.endDate && !this.networkId){
        SaleService.getTotalSales()
          .then(response => {
            this.count = response.data;
            //console.log(response.data);
          })
          .catch(e => {
            console.log(e);
          });
        
        SaleService.getAll(this.page, this.pageSize)
        .then(response => {
          this.sales = response.data;
          //console.log(response.data);
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
        });
      }
      
    },

    handlePageChange(value) {
      this.page = value;
      this.retrieveSales();
    },

    handlePageSizeChange(event) {
      this.pageSize = event.target.value;
      this.page = 1;
      this.retrieveSales();
    },

    refreshList() {
      this.retrieveSales();
      this.currentSale = null;
      this.currentIndex = -1;
    },

    setActiveSale(sale, index) {
      this.currentSale = sale;
      this.currentIndex = index;
    },

    removeAllSales() {
      SaleService.deleteAll()
        .then(response => {
          console.log(response.data);
          this.refreshList();
        })
        .catch(e => {
          console.log(e);
        });
    },
    
    /*searchSoldDate() {
      SaleService.getSalesByDate(new Date(this.startDate), new Date(this.endDate))
        .then(response => {
          this.sales = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },*/

    newSale() {
      this.$router.push('/addsale');
    }
  },
  mounted() {
    this.retrieveSales();
  }
};
</script>

<style>
.list {
  text-align: left;
  max-width: 100%;
  margin: auto;
  margin-top: 3.2em;
}
.paginate{
  margin-top: 1.7em;
}
.hgap{
  clear: both;
  margin-top: 1.1em;
}

.gridview
{
    border-collapse: collapse;
    margin: 0px 10px 10px 0;
    /*box-shadow: 3px 3px 4px #bbb;*/
    width: 100%;
    max-width: 100%;    
}

.gridview, .gridview td,  .gridview th
{
    border:  1px solid #cccccc;
}

.gridview th
{
    text-align: left;
    /*font-size: 1.2em;*/
    font-weight: normal;
    color: #F9F9F9;    
    background: #232324;
}

.gridview th a, .gridview th a:link, .gridview th a:visited, .gridview th a:active
{
    color: #fff;
    text-decoration: none;
}

.gridview th a:hover
{
    text-decoration: underline;
}

.gridview tr
{
    background: #fff;
}

.gridview tr:nth-child(odd) 
{
    background-color: #fff;
}
.gridview tr:nth-child(even) 
{
    background-color: #fff;
}

.gridview td 
{
    font-weight: normal;    
    text-align: left;
    vertical-align: top;
}

.gridview td, table th
{
    padding: 5px 8px;
}

.gridview tfoot td
{
    background-color: #fff;
}

.gridview tfoot td .page
{
    color: #000000;
    font-weight: bold;
}

.gridview tr.subfoot, .gridview tr.subfoot td
{
    background-color: #1E90FF;
}

.gridview tr:hover td, .gridview tbody tr:hover td
{
    background-color: #1E90FF;
    color: #fff;
}

.gridview .selected, .gridview tr td .selected
{
    background-color: #1E90FF;
    color: #fff;
}

.gridview tr.active td, .gridview tbody tr.active td
{
    background-color: #1E90FF;
    color: #fff;
}
</style>